'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var cx = require('classnames');
var Suggestion_module = require('./Suggestion.module.scss.js');
var Highlighted = require('../Highlighted/Highlighted.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var Suggestion = function (_a) {
    var className = _a.className, highlight = _a.highlight, onClick = _a.onClick, role = _a.role, text = _a.text, children = _a.children;
    return (jsxRuntime.jsx("li", tslib.__assign({ className: cx__default.default('list-group-item', 'p-0', Suggestion_module.default['suggestion__container'], className) }, { children: jsxRuntime.jsx("button", tslib.__assign({ className: "w-100 d-flex border-0 bg-white py-1 px-3 align-items-center", onClick: onClick ? function (e) { return onClick(e); } : undefined, role: role, type: "button" }, { children: children ? (children) : (jsxRuntime.jsx(Highlighted.Highlighted, { className: Suggestion_module.default['suggestion__text'], highlight: highlight, highlightClassName: Suggestion_module.default['suggestion__text--bold'], text: text })) })) })));
};

exports.Suggestion = Suggestion;
//# sourceMappingURL=Suggestion.js.map
